import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'text-editor',
  templateUrl: 'text-editor.html'
})
export class TextEditorComponent {

  @Input() text: string;
  @Output() textChange = new EventEmitter<string>();

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/text-editor/text-editor.ts